import { createReducer } from '@reduxjs/toolkit'
import reducers from './reducers'
import initialState from './reducers/initialState'
import { ProductsState } from './types'

const reducer = createReducer<ProductsState>(initialState, reducers)

export default reducer
